import React, { useEffect } from 'react'
import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'

type RichTextFieldProps = {
	value?: string
	onChange?: (html: string) => void
	placeholder?: string
	className?: string
	style?: React.CSSProperties
}

export function RichTextField({ value, onChange, placeholder, className, style }: RichTextFieldProps) {
	const { quill, quillRef } = useQuill({ theme: 'snow', placeholder })

	useEffect(() => {
		if (quill && value !== undefined && quill.root.innerHTML !== value) {
			quill.clipboard.dangerouslyPasteHTML(value)
		}
	}, [quill])

	useEffect(() => {
		if (!quill || !onChange) return
		const handler = () => onChange(quill.root.innerHTML)
		quill.on('text-change', handler)
		return () => {
			quill.off('text-change', handler)
		}
	}, [quill, onChange])

	return <div ref={quillRef} className={className} style={style} />
}
